import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const highlightedFeedActionContainer = style([
  {
    width: '100%',
    display: 'flex',
    minWidth: 0,
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
      alignItems: 'end',
      justifyContent: 'center',
      gap: space.s6,
    },
    tablet: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: space.s10,
    },
  }),
]);
